import request from '@/utils/request'

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: { object: {} },
	sign: 'dafdsf'
}
// 新增班次
export function addWorkShiftApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/work-shift/add',
		method: 'post',
		data: obj
	})
}
// 修改班次
export function updateWorkShiftApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/work-shift/update',
		method: 'put',
		data: obj
	})
}
// 分页查询班次
export function queryWorkShiftApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/work-shift/query',
		method: 'post',
		data: obj
	})
}
// 根据班次id查询
export function queryWorkShiftDetailByIdApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/work-period/query',
		method: 'get',
		params: obj
	})
}
// 批量删除班次
export function delWorkShiftApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/work-shift/batch/delete',
		method: 'put',
		data: obj
	})
}
// 新增请假类型
export function addLeaveTypeApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/leave-type/add',
		method: 'post',
		data: obj
	})
}
// 修改请假类型
export function updateLeaveTypeApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/leave-type/update',
		method: 'put',
		data: obj
	})
}
// 分页查询请假类型
export function queryLeaveTypeApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/leave-type/query',
		method: 'post',
		data: obj
	})
}
// 删除请假类型
export function delLeaveTypeApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/leave-type/batch/delete',
		method: 'put',
		data: obj
	})
}
// 新增请假
export function addLeaveApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/leave-info/add',
		method: 'post',
		data: obj
	})
}
// 修改请假
export function updateLeaveApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/leave-info/update',
		method: 'put',
		data: obj
	})
}
// 分页查询请假
export function queryLeaveApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/leave-info/query',
		method: 'post',
		data: obj
	})
}
// 删除请假
export function delLeaveApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/leave-info/batch/delete',
		method: 'put',
		data: obj
	})
}
/**
 * 新增加班
 * */
export function addOvertimeApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/overtime-info/add',
		method: 'post',
		data: obj
	})
}

/**
 * 编辑加班
 * */
export function updateOvertimeApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/overtime-info/update',
		method: 'put',
		data: obj
	})
}
/**
 * 批量删除加班
 * */
export function delOvertimeApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/overtime-info/batch/delete',
		method: 'put',
		data: obj
	})
}
/**
 * 分页查询加班
 * */
export function queryOvertimeApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/overtime-info/query',
		method: 'post',
		data: obj
	})
}
/**
 * 查询考勤记录详情
 * */
export function queryAttendanceRecordApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/shift-detail/query',
		method: 'post',
		data: obj
	})
}
/**
 * 分页查询考勤记录班段详情
 * */
export function queryAttendanceRecordDetailApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/period-detail/query',
		method: 'post',
		data: obj
	})
}
/**
 * 修改考勤记录异常
 * */
export function updateAttendanceRecordApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/shift-detail/update/result',
		method: 'put',
		data: obj
	})
}
// 批量排班
export function plAddWorkforce (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/scheduling-info/batch/scheduling',
		method: 'post',
		data: obj
	})
}
/**
 * 新增考勤设备 传参方式post
 * */
export function addDeviceInfoApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/device-info/add',
		method: 'post',
		data: obj
	})
}
/**
 * 修改考勤设备 传参方式put
 * */
export function updateDeviceInfoApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/device-info/update',
		method: 'put',
		data: obj
	})
}
/**
 * 批量删除考勤设备 传参方式put
 * */
export function delDeviceInfoApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/device-info/batch/delete',
		method: 'put',
		data: obj
	})
}
/**
 * 分页查询考勤设备 传参方式put
 * */
export function queryDeviceInfoApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/device-info/query',
		method: 'post',
		data: obj
	})
}
// 查询个人排班详情
export function getWorkforcePersonal (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/scheduling-info/query/single-customer',
		method: 'put',
		data: obj
	})
}
/**
 * 分页查询人员出勤汇总 传参方式put
 * */
export function queryPersonalSummaryApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/shift-detail/personal-summary',
		method: 'post',
		data: obj
	})
}

// 个人考勤迟到记录（查询）
export function getLateListPersonApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/shift-detail/personal-summary/late',
		method: 'post',
		data: obj
	})
}
// 个人考勤早退记录（查询）
export function	getEarlyListPersonApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/shift-detail/personal-summary/early',
		method: 'post',
		data: obj
	})
}
// 个人考勤旷工记录（查询）
export function	getTruancyListPersonApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/shift-detail/personal-summary/absent',
		method: 'post',
		data: obj
	})
}
// 个人考勤请假记录（查询）
export function	getVacateListPersonApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/shift-detail/personal-summary/leave',
		method: 'post',
		data: obj
	})
}
// 个人考勤休息日加班记录（查询）
export function	getOverTimeListPersonApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/shift-detail/personal-summary/overtime',
		method: 'post',
		data: obj
	})
}
// 组织考勤部门汇总查询
export function queryDepSummaryApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/shift-detail/department-summary',
		method: 'post',
		data: obj
	})
}
// 组织考勤迟到记录（查询）
export function getLateListOrgApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/shift-detail/department-summary/late',
		method: 'post',
		data: obj
	})
}
// 组织考勤早退记录（查询）
export function	getEarlyListOrgApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/shift-detail/department-summary/early',
		method: 'post',
		data: obj
	})
}
// 组织考勤旷工记录（查询）
export function	getTruancyListOrgApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/shift-detail/department-summary/absent',
		method: 'post',
		data: obj
	})
}
// 组织考勤请假记录（查询）
export function	getVacateListOrgApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/shift-detail/department-summary/leave',
		method: 'post',
		data: obj
	})
}

// 组织考勤工作日加班记录（查询）
export function	getWorkingListOrgApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/shift-detail/department-summary/overtime',
		method: 'post',
		data: obj
	})
}

// 组织考勤详情记录（查询）
export function	getDetailListOrgApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/shift-detail/department-summary/attendance-population',
		method: 'post',
		data: obj
	})
}
// 导入请假信息
export function	uploadVacateApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/leave-info/import-excel',
		method: 'post',
		data
	})
}

// 导入请假信息
export function	uploadOverTimeApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/overtime-info/import-excel',
		method: 'post',
		data
	})
}
// 组织考勤详情记录（查询）
export function	getPunchCardLogApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/attendance/punch-card-log/query',
		method: 'post',
		data: obj
	})
}
